import { useState } from "react";
import { http } from "Utils/http";
import DatatableBase from 'Components/Datatable/DatatableBase'
import { Datatable_Column } from "Components/Datatable/DatatableComponents/DatatableColumn";
import { store } from 'Store';

const PSETestBatchDeleted = () => {

  const loginState = store.getState().loginInfo;
  const token = "Bearer " + loginState.token;

  // Date format: mm/dd/yyyy hh: mm
  const handleDateFormat = (time) => {

    let date = new Date(time);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hour = date.getHours();
    let min = date.getMinutes();

    return (
      <div>
        {month < 10 ? "0" + month : month}/
        {day < 10 ? "0" + day : day}/
        {year + " "}
        {hour < 10 ? "0" + hour : hour}:
        {min < 10 ? "0" + min : min}
      </div>
    )
  }

  /** Start of deletedPSETestBatch */
  const deletedPSETestBatchHeader = "Test Data Deletion Activity";
  const deletedPSETestBatchSearchFieldText = "Search by ID";

  // Set deletedPSETestBatchSortColumn state; default sort: updatedDate desc
  const [deletedPSETestBatchSortColumn, setDeletedPSETestBatchSortColumn] = useState({
    sortField: "addedDate",
    sortDirection: "desc"
  });

  // Flag: trigger api to reload data
  const [reloadDeletedPSETestBatch, setReloadDeletedPSETestBatch] = useState(false);
  const [selected, setSelected] = useState(
    {
      allSelected: false,
      selectedCount: 0,
      selectedRows: []
    });

  /*
  Column structure:
    {
      name: <div tabIndex={0} className="datatable-col-name">Batch ID  <div className="dataTableSortIcon"><RenderSortIcon sortDirection={deletedPSETestBatchSortColumn.sortField == "pseBatchId" ? deletedPSETestBatchSortColumn.sortDirection : ""} /></div></div>,
      //name: 'Batch ID',row.pseBatchId,
      selector: row => <a href="">{row.pseBatchId}</a>,
      sortable: true,
      sortField: 'pseBatchId',
      //width: "12%",
    }
  */
  const getListCols = (selectedList, sortingInfo) => {
    const listColumns = [];
    listColumns.push(Datatable_Column({ name: "PSO ID", columnName: "psoId", selectedRows: selectedList, sortable: true, sortFieldNum: 0, sortingInfo: sortingInfo }))

    listColumns.push(Datatable_Column({ name: "Batch ID", columnName: "pseBatchId", selectedRows: selectedList, sortable: true, sortFieldNum: 0, sortingInfo: sortingInfo }))
    listColumns.push(Datatable_Column({ name: "Setting", columnName: "cfSetting", selectedRows: selectedList, sortable: true, sortFieldNum: 1, sortingInfo: sortingInfo }))
    listColumns.push(Datatable_Column({ name: "Requested By", columnName: ["firstName", "lastName"], concatColName: "fullName", selectedRows: selectedList, sortable: true, sortFieldNum: 2, sortingInfo: sortingInfo }))
    listColumns.push(Datatable_Column({ name: "Batch Status", columnName: "batchStatusDesc", selectedRows: selectedList, sortable: true, sortFieldNum: 3, sortingInfo: sortingInfo }))
    listColumns.push(Datatable_Column({ name: "Requested Date", columnName: "addedDate", selectedRows: selectedList, sortable: true, sortFieldNum: 4, formatFunction: handleDateFormat, sortingInfo: sortingInfo }))

    return listColumns;
  }

  // ajax call to load PSE Test Batch Deleted data
  const getData = async (filter) => {
    var call = {
      paginationRequest: filter,
      isTestSubmission: "Y"
    }

    var url = '/api/cda/deletedBatch';

    return http.post(url, call, {
      headers: {
        "Authorization": token
      }
    });
  }

  return (
    <>
      <DatatableBase
        tableClassName="cdaTestDeletedTable"
        reload={reloadDeletedPSETestBatch}
        setReload={setReloadDeletedPSETestBatch}
        getData={getData}
        getListCols={getListCols}
        setSelected={setSelected}
        hasSelectableRows={false}
        searchFieldText={deletedPSETestBatchSearchFieldText}
        datatableHeader={deletedPSETestBatchHeader}
        datatableDescription={null}
        sortingColumn={deletedPSETestBatchSortColumn.sortField}
        sortingOrder={deletedPSETestBatchSortColumn.sortDirection}
      >
      </DatatableBase>
    </>
  )
}

export default PSETestBatchDeleted